/*
 * @Author: your name
 * @Date: 2021-04-12 11:38:40
 * @LastEditTime: 2021-07-29 16:09:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cloud-record\src\assets\js\common\utils.js
 */
import toTipsObj from './toTipsObj.js'

const TokenKey = 'SID'
import Cookies from 'js-cookie'
const domain = document.domain.split('.').slice(-2).join('.')

let Tool = {
  //获取地址栏参数
  // 获取session
  getSession() {
    // 获取session
    let href = window.location.href
    let session = href.split('session=')[1]
    if (session && session.length > 32) {
      session = session.substr(0, 32)
      window.localStorage.setItem('session', session)
    }
    return session
  },
  // 返回UTC时间
  getUTCTime(date) {
    return date.getTime() + date.getTimezoneOffset() * 60000
  },
  getQueryString(name, str, symbol) {
    str = (str == null ? window.location.search.substr(1) : str)
    symbol = (symbol == null ? '&' : symbol)
    var reg = new RegExp('(^|' + symbol + ')' + name + '=([^' + symbol + ']*)(' + symbol + '|$)', 'i')
    var r = str.match(reg)
    if (r != null) return unescape(r[2])
    return null
  },
  //公共提示方法
  ToTip(errorCode, type, deafaultTip) {
    /*
     *  lang=>对应的中英文翻译
     *  type=>提示类型
     *  errorCode=>错误代码
     *  deafaultTip=>默认的其它的提示或在此方法内找不到对应code的提示
     * */
    let messageText = toTipsObj[errorCode] ? toTipsObj[errorCode] : deafaultTip
    let warningType = type ? type : 'warning'
    if (!messageText) {//所有的提示都没有给
      messageText = 'lang.error'
      console.log('Don\'t give tips key => 没有给提示的关键字')
    }
    messageText = i18n.t(messageText)
    window.vue.$message({
      message: messageText,
      type: warningType
    })
  },
  getCookie() {
    // 获取session
    // return Cookies.get(TokenKey) || localStorage.getItem("session");
    return Cookies.get(TokenKey)
  },
  setCookie(session) {
    let domain = '.tvunetworks.com'
    if (!location.host.includes(domain)) {
      domain = '.tvunetworks.cn'
    }
    // localStorage.setItem("session", session);
    // return Cookies.set(TokenKey, session, { domain, expires: 20 });
  },
  removeCookie() {
    localStorage.removeItem('session')
    return Cookies.remove(TokenKey, { domain })
  }
}

export default Tool
